<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <div class="content">
            <div class="content-header">
                <Backbutton />
                Редактирование заявки
            </div><br>
            <div class="header-for-input"><b>Информация о заявке</b></div>
            <div v-show="permissions.show_marking_button" class="btn_main_button" @click="$router.push('/kcop/mark/'+kcop.id)">Ввести оценки</div>
            <br>
            <hr /><br>
            ID Заявки: {{ kcop.id }} <br><br>
            Статус заявки: {{ ref_statuses[kcop.status_id] }} <br><br>
            <select v-show="permissions.edit_status_in_kcop" class="content-input input_width_50" v-model="kcop.status_id">
                <option value="0">Не выбрано</option>
                <option v-for="key, index in ref_statuses" :key="index" :value="index">{{ key }}</option>
            </select>
            <br><br>
            Доп. статус заявки: {{ ref_ext_statuses[kcop.ext_status] }} <br><br>
            <select v-show="permissions.edit_ext_status_in_kcop" class="content-input input_width_50" v-model="kcop.ext_status">
                <option v-for="key, index in ref_ext_statuses" :key="index" :value="index">{{ key }}</option>
            </select>
            <br>
            <div class="btn_main_button" v-show="permissions.edit_status_in_kcop" @click="update_status()">Обновить статус</div>
            <br><br>
            <div class="header-for-input"><b>Информация о компании</b></div>
            <hr />
            <br>
            Полное наименование компании: {{ kcop.company }} <br><br>
            ИНН компании: {{ kcop.inn }} <br><br>
            Адрес компании: {{ kcop.address }} <br><br><br>

            <a v-show="permissions.edit_status_in_kcop" :href="'/company/'+kcop.company_id+'/edit'">Редактировать данные компании</a>
            <br><br><br>

            <div class="header-for-input"><b>Информация о пользователе (Создатель заявки)</b></div>
            <hr />
            <br>
            ФИО : {{ kcop.username }} <br><br>
            Email : {{ kcop.inn }} <br><br>
            Телефон : {{ kcop.phone }} <br><br>
            Должность : {{ kcop.position }} <br><br><br>

            <a v-show="permissions.edit_status_in_kcop" :href="'/users/show/'+kcop.user_id">Редактировать данные пользователя</a>

             <br><br><br>

            <div class="header-for-input"><b>Загруженные файлы (Доументы)</b></div>
            <br><br>
            <div class="header-for-input"><pre>Презентация: <a v-show="file_to_api_path(uploaded.presentation.path_file).is_uploaded" :href="file_to_api_path(uploaded.presentation.path_file).file_src">Просмотреть загруженный файл</a></pre></div>

            <div class="header-for-input"><pre>Видеоролик: <a v-show="file_to_api_path(uploaded.video.path_file).is_uploaded" :href="file_to_api_path(uploaded.video.path_file).file_src">Просмотреть загруженный файл</a></pre></div>

            <div class="header-for-input"><pre>Решение кейса: <a v-show="file_to_api_path(uploaded.solvedcase.path_file).is_uploaded" :href="file_to_api_path(uploaded.solvedcase.path_file).file_src">Просмотреть загруженный файл</a></pre></div>

            <div class="header-for-input"><pre>Официальное письмо: <a v-show="file_to_api_path(uploaded.oficialmail.path_file).is_uploaded" :href="file_to_api_path(uploaded.oficialmail.path_file).file_src">Просмотреть загруженный файл</a></pre></div>
            
            
            
        </div>
    </div>
</template>

<script>

import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Backbutton from '@/components/elements/bacl-button.vue'

export default {
    name: 'EditKcop',
    components: {
        Success, Error, Backbutton
    },
    props: {
        id: String
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            kcop: {
                id: 0,
                company_id: 0,
                user_id: 0,
                company: '',
                inn: '',
                address: '',
                username: '',
                email: '',
                phone: '',
                position: '',
                status_id: '',
                ext_status: '',
            },
            ref_statuses: {
                1: 'На рассмотрении',
                2: 'Зарегистрировано',
                3: 'Отклонено',
            },
            ref_ext_statuses: {
                0: 'Не установлен',
                1: 'Допущено к защите',
                2: 'Победитель конкурсного отбора'
            },
            uploaded: {
                presentation: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                },
                video: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                },
                solvedcase: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                },
                oficialmail: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                }
            },
            permissions: {}
            

        }
    },
    methods: {
        file_to_api_path(file_name) {
            if((file_name != null)&&(file_name != '')) 
                return {
                    is_uploaded: true,
                    file_src: process.env.VUE_APP_API_URL+'/storage/'+file_name,
                }
            else
                return {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                }
                    
        },
        get_kcop() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop/show/'+this.id)
                .then(response => {
                    this.kcop = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        get_uploaded() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop/uploaded/'+this.id)
            .then(response => {
              loader.hide()
                console.log(response.data.data)
                //this.get_uploaded_file()
                this.uploaded = response.data.data

            })
            .catch(error => {
                loader.hide();
                 this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        update_status() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop/status/'+this.id+'/update/'+this.kcop.status_id+'/'+this.kcop.ext_status)
            .then(response => {
              loader.hide()
                console.log(response.data.data)
                //this.get_uploaded_file()
                this.get_kcop()

            })
            .catch(error => {
                loader.hide();
                 this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        }
    },
    created() {
        this.permissions =  JSON.parse(localStorage.getItem('permissions'))
        //console.log(this.permissions)
        this.get_kcop()
        this.get_uploaded()
    }
}

</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>